import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";

function Registration() {
  const initialValues = {
    username: "",
    password: "",
    email   : "", 
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().min(3).max(15).required(),
    password: Yup.string().min(4).max(20).required(),
    email: Yup.string().min(11).max(50).required(),
  });

  const onSubmit = (data) => {
    axios.post("https://api.inloop.live/auth", data).then(() => {
      console.log(data.data);
      console.log(data);
    });
    alert("You are registered. Go to login for the same account!")
  };

  return (
    <div className="loginContainer">
      <h1>Registration</h1>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        id="inputFormik"
        class="inputCreatePost"
      >
        <Form className="formContainer" id="form">
          <label for="inputName">Username: </label>
          <ErrorMessage name="username" component="span" />
          <Field
            autocomplete="off"
            id="inputName"
            name="username"
            placeholder="(Ex. John123...)"
            className="inputCreatePost"
          />

          <label for="inputPassword">Password: </label>
          <ErrorMessage name="password" component="span" />
          <Field
            autocomplete="off"
            type="password"
            id="inputPassword"
            name="password"
            placeholder="Your Password..."
            className="inputCreatePost"
          />

          <label for="inputEmail">E-mail: </label>
          <ErrorMessage name="email" component="span" />
          <Field
            autocomplete="off"
            type="email"
            id="inputEmail"
            name="email"
            placeholder="Your Email..."
            className="inputCreatePost"
          />
<label for="btnSub">
      <h1>About</h1>
      <p>
      Hi/Hey this is the users space to find and create
       transactions from those of you willing to provide it once off
      such as advertising and one event sales. We try to be as fair
      and accomodating as possible.Even You can create a post to help
       others. We aim to help start ups and reduce the need for 
      pop up ads. These are less expensive and way more effective.
       With us you can create genuine published works that annoy no one,
       actually attract customersand diversify your reach! On the other
        hand you would benefit from the once off transactions and stay
      in the loop! This is the safest space for any and all transactions.
       If we might add we recommend ad-proposals, job hirings and sales
        here for reasons included below!</p>
      <h2>Terms and Conditions</h2>
      <ol>
        <li><b>The selection process will take 25% of those who qualify over others
           and 75% chosen randomly from the magnitude chosen by the poster
            where stated so.</b></li>
        <li><b>All payments made from us to any individual in your
           behalf are non-refundable.</b></li>
        <li><b>All payments made to us are majorily for assurance and can be
           refunded after deducting fees.</b></li>
        <li><b>The real transaction will be made through us via 
          call or email and we check for the following:

           In cases of both parties satisfied...Assurance for both is send back
            accordingly after deducting fees. 
           In case of the poster at fault...Failing to validate/verify with the
            post means no assurance fee payed for poster and the rewardee gets
             theirs and the posters assurance bank.
           In case of the rewardee not proceeding with payment method...Failing to
            keep ones end of the deal also means forfeited assurance bank and 
            the poster gets theirs as well as a portion from the rewardees.</b></li>
        <li><b>The number of expected successful applicants are chosen by
           admins/moderators of the website thus by extend choosing 
           minimum pay per Post unless stated otherwise.</b></li>
          <li><b>Fees per post and reward apply for free advertising,
            services offered,assurance for paying rewardee and etc.</b></li>
          <li><b>Information provided is to be processed in
             the selection process.</b></li>
          <li><b>This website follows the rules and regulations
             of the host where applicable.</b></li>
          <li><b>This website and all its components excludng hosting
             and user data are properties of
            Inator Industrial Mechanisms (Pty) Ltd reserved under
             Company Intellectual Property Commision.</b></li>
      </ol>
      <h2>Privacy Policy</h2>
      <ul>
        <li>Data provided by user is to be processed under validation,
           verification and selection.</li>
        <li>The host of the website has a right to access user data
           in selection,security,editing or terminationof the account
            under fraud or others but only limited to them,yourself and
             the website moderators.</li>
      <li>If provided data is proven to be incorrect or incomplete, 
        the user will be limited from the website or banned.</li>
      <li>All posts and comments are visible for everyone to see.</li>
      </ul>
      <h2>Copyright</h2>
      <p>This is property of 
        Inator Industrial Mechanisms (Pty) Ltd reserved under
         Company Intellectual Property
        Commission.
      </p>
      <h1>User Agreements</h1>
      <ul>
        <li><b>Users must provide correct and complete data.</b></li>
        <li>Users hold full responsibility for copyright issues
           with provided data.<br></br>
      In cases of successful applications, the user(s) is expected
       to provide proof that they kept their part of the deal AND provide
        a clear way of payment. If the payment data is incorrect the user
       has no right to appeal and they lost their monetary gain.<br></br>
      If the user fails to provide proof to our contacts within a
       month they automatically forfeit their reward.</li>
      <li>Users will follow both rules of the host of the website
         and the website as well.</li>
      </ul>
      </label>

     

          <button id="btnSub" type="submit"> Register</button>
           <h2>By registering you agree to the mentioned terms</h2>
        </Form>
      </Formik>

    </div>
  );
}

export default Registration;
